<template>
    <v-textarea
          :outlined="outlined"
          :auto-grow="autoGrow"
          :label="label"
          v-model="model"
          :hide-details="hideDetails"
          :error-messages="errorMessages"
          :placeholder="placeholder"
          :disabled="disabled"
          :background-color="backgroundColor"
          :rows="rows"
        ></v-textarea>
</template>

<script setup>

import { defineProps, computed, defineEmits } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
    value: [String, Number],
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    outlined: { type: Boolean, required: false },
    hideDetails: { type: [String, Boolean], default: "auto"},
    errorMessages: { type: [Object, Array], required: false },
    disabled: { type: Boolean, default: false },
    autoGrow: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 3 },
})

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

const backgroundColor = computed(() => {
    return props.disabled ? 'grey lighten-2' : ''
})


</script>